var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("主页面")]),_c('p',[_vm._v("token："+_vm._s(_vm.token))]),_c('p',[_vm._v("当前皮肤："+_vm._s(_vm.curTheme))])])
}
var staticRenderFns = []

export { render, staticRenderFns }